import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Box } from '@mui/material';
import { getClubLogoPublicUrl, normalizeClubLogoId } from '../clubLogo';

const SupabaseClubLogo = React.memo(({
  clubID,
  size = 80,
  sx = {}
}) => {
  const [hasError, setHasError] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const normalizedClubId = normalizeClubLogoId(clubID);

  const imageSrc = useMemo(() => {
    if (!normalizedClubId) return null;
    return getClubLogoPublicUrl(normalizedClubId, { refreshKey });
  }, [normalizedClubId, refreshKey]);

  useEffect(() => {
    const handleLogoUpdate = (event) => {
      const updatedClubId = normalizeClubLogoId(event?.detail?.clubID);
      if (updatedClubId && normalizedClubId && updatedClubId !== normalizedClubId) {
        return;
      }
      setRefreshKey((prev) => prev + 1);
      setHasError(false);
    };

    window.addEventListener('clubLogoUpdated', handleLogoUpdate);
    return () => window.removeEventListener('clubLogoUpdated', handleLogoUpdate);
  }, [normalizedClubId]);

  useEffect(() => {
    setHasError(false);
    setRefreshKey(0);
  }, [normalizedClubId]);

  const handleImageError = useCallback(() => {
    setHasError(true);
  }, []);

  if (!imageSrc || hasError) {
    return null;
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <img
        src={imageSrc}
        alt="Club Logo"
        onError={handleImageError}
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          ...sx
        }}
      />
    </Box>
  );
});

export default SupabaseClubLogo;
